/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BrandsInputs */

const en_nav_brands = /** @type {(inputs: Nav_BrandsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brands`)
};

/**
* | output |
* | --- |
* | "Brands" |
*
* @param {Nav_BrandsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_brands = /** @type {((inputs?: Nav_BrandsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BrandsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_brands(inputs)
});